import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CelebrationButton from "@/components/ui/CelebrationButton/CelebrationButton";
import { checkboxOptions } from "./helper";
import Select from "react-select";
import { GetUnLocationByISOCodeList } from "@/redux/Common/actions";

const PortPlaceModal = ({
  open,
  onClose,
  formData,
  handleInputChange,
  onSave,
  errors,
}) => {
  if (!open) return null;

  console.log("errorserrors", errors);

  const [locations, setLocations] = useState([]);
  const { countryList } = useSelector((state) => state.common);
  const [loading, setloading] = useState(false);

  const { isAnimate } = useSelector((state) => state.toast);

  useEffect(() => {
    if (formData?.countryCode) {
      getLocations(formData?.countryCode);
    }
  }, [formData?.countryCode]);

  const selectContary = (selected) => {
    handleInputChange({
      target: { name: "countryCode", value: selected?.value },
    });
    handleInputChange({ target: { name: "country", value: selected?.label } });
    if (selected?.value) {
      handleInputChange({
        target: { name: "unisoCode", value: "" },
      });
    }
  };

  const getLocations = (code) => {
    setloading(true);
    GetUnLocationByISOCodeList(code)
      .then((res) => {
        // success logic

        const options = (res || [])?.map((loc) => ({
          value: loc.unLocationLOCCode,
          label: loc.unLocationDescription,
        }));

        setLocations([...options]);
      })
      .catch((err) => {
        // error logic
        console.log(err);
      })
      .finally(() => {
        setloading(false);
        console.log("Request completed");
      });
  };

  const options = (countryList || [])?.map((loc) => {
    const match = (loc.incoterm || "").match(/\(([^)]+)\)/);
    const code = match ? match[1] : null;
    return {
      value: code,
      label: loc.incoterm,
    };
  });

  const inputClass =
    "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all  disabled:bg-gray-200 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed";
  const selectClass =
    "w-full px-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all  disabled:bg-gray-200 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed";
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-12 overflow-auto">
      <div className="bg-white dark:bg-slate-800 w-[720px] rounded-md shadow-lg">
        {/* Header */}
        <div className="px-4 py-2 bg-sky-500 text-white font-medium rounded-t-md">
          Port/Place Information
        </div>

        <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800">
          {/* Body */}
          <div className="p-5 space-y-4">
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Entity Type:
              </label>
              <div className="col-span-9 flex gap-6">
                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="radio"
                    name="entityType"
                    value={0}
                    checked={formData?.entityType == 0}
                    onChange={handleInputChange}
                  />
                  Port
                </label>

                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="radio"
                    name="entityType"
                    value={1}
                    checked={formData?.entityType == 1}
                    onChange={handleInputChange}
                  />
                  Place
                </label>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Port Type:
              </label>
              <div className="col-span-9 flex gap-6">
                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="radio"
                    name="portType"
                    value="0"
                    checked={formData?.portType == 0}
                    onChange={handleInputChange}
                  />
                  USA Port
                </label>

                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="radio"
                    name="portType"
                    value="1"
                    checked={formData?.portType == 1}
                    onChange={handleInputChange}
                  />
                  Foreign Port
                </label>
              </div>
            </div>

            {/* Port Name */}
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Port Name: <span className="text-red-500">*</span>
              </label>
              <div className="col-span-9">
                <input
                  type="text"
                  name="cityPortName"
                  className={inputClass}
                  value={formData?.cityPortName || ""}
                  onChange={handleInputChange}
                />
                {errors?.cityPortName && (
                  <span className="text-red-500 text-[11px]">
                    {errors?.cityPortName}
                  </span>
                )}
              </div>
            </div>

            {/* Schedule D/K Code */}
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Schedule D/K Code:<span className="text-red-500">*</span>
              </label>
              <div className="col-span-9">
                <input
                  type="text"
                  name="scheduledCode"
                  className={inputClass}
                  value={formData?.scheduledCode || ""}
                  onChange={handleInputChange}
                />
                {errors?.scheduledCode && (
                  <span className="text-red-500 text-[11px]">
                    {errors?.scheduledCode}
                  </span>
                )}
              </div>
            </div>

            {/* Country ISO Code */}
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Country ISO Code: <span className="text-red-500">*</span>
              </label>
              <div className="col-span-9">
                <Select
                  options={options}
                  value={options?.find(
                    (opt) => opt.value === formData?.countryCode,
                  )}
                  onChange={(selected) => selectContary(selected)}
                  placeholder="Select Country"
                  classNames={{
                    control: (state) =>
                      `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                       ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"}`,
                    menu: () =>
                      "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                    option: ({ isFocused, isSelected }) =>
                      `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}  text-slate-900 dark:text-white`,

                    singleValue: () => "text-slate-900 dark:text-white",
                    placeholder: () => "text-slate-400 dark:text-slate-500",
                  }}
                />
                {errors?.countryCode && (
                  <span className="text-red-500 text-[11px]">
                    {errors?.countryCode}
                  </span>
                )}
              </div>
            </div>

            {/* Location Code */}
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Location (LOC Code): <span className="text-red-500">*</span>
              </label>
              <div className="col-span-9">
                <Select
                  options={locations}
                  value={locations?.find(
                    (opt) => opt.value === formData?.unisoCode,
                  )}
                  onChange={(selected) =>
                    handleInputChange({
                      target: { name: "unisoCode", value: selected?.value },
                    })
                  }
                  isDisabled={!formData?.countryCode || loading}
                  placeholder="Select Location"
                  classNames={{
                    control: (state) =>
                      `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                       ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"}`,
                    menu: () =>
                      "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                    option: ({ isFocused, isSelected }) =>
                      `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}  text-slate-900 dark:text-white`,

                    singleValue: () => "text-slate-900 dark:text-white",
                    placeholder: () => "text-slate-400 dark:text-slate-500",
                  }}
                />
                {errors?.unisoCode && (
                  <span className="text-red-500 text-[11px]">
                    {errors?.unisoCode}
                  </span>
                )}
              </div>
            </div>

            {/* Notes */}
            <div className="grid grid-cols-12 gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Notes:
              </label>
              <div className="col-span-9">
                <textarea
                  rows={3}
                  name="portNotes"
                  className={inputClass}
                  value={formData?.portNotes || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="grid grid-cols-12 gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Type:
              </label>

              <div className="col-span-9 grid grid-cols-2 gap-2 text-sm">
                {checkboxOptions &&
                  checkboxOptions.map((item) => (
                    <CheckboxItem
                      key={item.name}
                      label={item.label}
                      name={item.name}
                      checked={formData?.[item.name]}
                      onChange={handleInputChange}
                    />
                  ))}
              </div>
            </div>

            {/* Footer Note */}
            <div className="text-xs text-slate-500">
              * Marks are mandatory fields.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-center gap-2 px-4 py-3 border-t dark:border-slate-700">
          <CelebrationButton
            onClick={() => onSave()}
            label={Number(formData?.id) ? "Update" : "Save"}
            className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
            icon={<></>}
            isSuccess={isAnimate}
          />

          <button
            onClick={onClose}
            className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PortPlaceModal;

const CheckboxItem = ({ label, name, checked, onChange }) => {
  return (
    <label className="flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        name={name}
        checked={checked || false}
        onChange={(e) =>
          onChange({
            target: {
              name,
              value: e.target.checked,
            },
          })
        }
        className="accent-teal-600"
      />
      <span className="text-slate-700 dark:text-slate-300">{label}</span>
    </label>
  );
};
